import React from 'react'

const LineLoader = () => {
    return (
        <div className="flex flex-col justify-center items-center w-12 h-6 ml-5">
            <span className="relative inline-block w-24 h-1 bg-gray-200 overflow-hidden rounded">
                <span className="absolute left-0 top-0 h-full w-1/3 bg-blue-500 animate-loading-bar"></span>
            </span>
        </div>
    )
}

export default LineLoader;